"use client"

import { Mic, FileText, CheckCircle, Calendar } from "lucide-react"
import { useEffect, useState } from "react"

export function AboutSection() {
  const fullText = "PolyMeet transforme vos réunions physiques en informations exploitables, décisions claires et actions concrètes."
  const [displayText, setDisplayText] = useState("")
  const [index, setIndex] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => {
      setDisplayText(fullText.slice(0, index + 1))
      setIndex(prev => (prev + 1 > fullText.length ? 0 : prev + 1))
    }, 30)
    return () => clearInterval(interval)
  }, [index])

  return (
    <section
      id="about"
      className="relative pt-36 pb-24 bg-gradient-to-br from-white via-[#f3edff] to-white overflow-hidden"
    >
      <div className="absolute top-20 left-10 w-72 h-72 bg-[#5e17eb]/10 rounded-full blur-3xl animate-blob animation-delay-2000" />
      <div className="absolute bottom-20 right-10 w-72 h-72 bg-[#5e17eb]/20 rounded-full blur-3xl animate-blob animation-delay-4000" />

      <style>{`
        @keyframes blob {
          0%,100% { transform: translate(0,0) scale(1); }
          33% { transform: translate(20px,-10px) scale(1.05); }
          66% { transform: translate(-15px,10px) scale(0.95); }
        }
        .animate-blob { animation: blob 8s infinite; }
        .animation-delay-2000 { animation-delay: 2s; }
        .animation-delay-4000 { animation-delay: 4s; }

        /* Card icon float */
        .icon-float { animation: float 3s ease-in-out infinite alternate; }
        @keyframes float {
          0% { transform: translateY(0px); }
          50% { transform: translateY(-6px); }
          100% { transform: translateY(0px); }
        }
      `}</style>

      <div className="relative max-w-7xl mx-auto px-6">
        <div className="text-center mb-20">
          <h2 className="text-4xl md:text-5xl font-extrabold text-black min-h-[120px]">
            {displayText}
            <span className="border-r-2 border-black animate-pulse ml-1">&nbsp;</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          <Card
            icon={<Mic />}
            title="Capture intelligente"
            text="Enregistrement et transcription automatique des réunions en temps réel."
          />
          <Card
            icon={<FileText />}
            title="Résumé automatique"
            text="Synthèse claire des points clés sans effort humain."
          />
          <Card
            icon={<CheckCircle />}
            title="Tâches détectées"
            text="Extraction intelligente des actions et attribution aux participants."
          />
          <Card
            icon={<Calendar />}
            title="Suivi structuré"
            text="Organisation et continuité entre réunions."
          />
        </div>
      </div>
    </section>
  )
}

function Card({ icon, title, text }) {
  return (
    <div className="group relative bg-white rounded-2xl p-8 shadow-xl border border-[#ebe5ff]
      transition-all duration-500 hover:-translate-y-4 hover:shadow-2xl">

      <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-[#5e17eb]/20 to-transparent
        opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

      <div className="relative z-10 text-center">
        <div className="w-14 h-14 mb-6 rounded-xl bg-gradient-to-br from-[#5e17eb] to-[#8b5cf6]
          flex items-center justify-center text-white group-hover:scale-110 transition-transform duration-300 icon-float">
          {icon}
        </div>
        <h4 className="text-xl font-bold text-gray-900 mb-3">{title}</h4>
        <p className="text-gray-600 text-sm leading-relaxed">{text}</p>
      </div>
    </div>
  )
}
